import { LdsProps } from '~/components/LdsBlock/models';
import { pageBlockUIMapper } from '~/mappers/pageBlock';

import { PageBlock } from './models';

export const ldsBlockMapper = ({
  fields: { ldsContent },
  pageBlockUI,
  updatedLdsContent,
}: PageBlock): LdsProps => ({
  ldsContent: updatedLdsContent ?? ldsContent,
  pageBlockUI: pageBlockUIMapper(pageBlockUI[0].ui),
});
